<form class="row" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="col-md-6">
    <div class="form-group">
      <label for="identification-type">Tipo de Identificación: </label><span class="required-mark"> * </span>
      <ng-select
        bindLabel="nombre"
        bindValue="id"
        formControlName="identificationType"
        [items]="identificationTypes$ | async"
        labelForId="identification-type"
      ></ng-select>
    </div>
  </div>
  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Número de Identificación: </uni-label>
      <input uniInput formControlName="identification" />
    </uni-form-field>
  </div>

  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Nombre(s): </uni-label>
      <input uniInput formControlName="name" />
    </uni-form-field>
  </div>
  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Apellido(s): </uni-label>
      <input uniInput formControlName="lastName" />
    </uni-form-field>
  </div>

  <div class="col-12">
    <div class="form-group">
      <label for="province">Provincia: </label><span class="required-mark"> * </span>
      <ng-select bindLabel="nombre" formControlName="province" [items]="provinces$ | async" labelForId="province"></ng-select>
    </div>
  </div>

  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Teléfono: </uni-label>
      <input uniInput format="(000) 000-0000" formControlName="telephone" type="tel" />
    </uni-form-field>
  </div>
  <div class="col-md-6">
    <app-date-input label="Fecha de Cumpleaños" formControlName="birthDate" [requiredMark]="true"></app-date-input>
  </div>

  <div class="col-12 text-right pt-3">
    <button type="submit" uni-button icon="chevron-right" [disabled]="form.invalid" uniStepperNext>Continuar</button>
  </div>
</form>
